/**
 * `/api/agents/triage` — UI read of the #45530 ranked board
 * (`excellent-mcp triage list`).
 *
 * Wire only. The handler shells out to the existing CLI and returns that
 * payload. Do not re-rank here. Failure is payload, not an HTTP error.
 */

import { z } from "zod";
import type { Operation } from "../types";

export type TriageBand = "P0" | "P1" | "P2" | "P3" | "P4" | "HUMAN";

export interface TriageBoardRowDto {
  id: number;
  title: string;
  status: string;
  score: number;
  structural: number;
  band: TriageBand;
  rescope: boolean;
  reasons: string[];
}

export interface TriageBoardViewDto {
  generatedAt: string;
  total: number;
  matched: number;
  rows: TriageBoardRowDto[];
}

export type TriageBoardResult =
  | { ok: true; status: TriageBoardViewDto }
  | { ok: false; error: string };

const listQuery = z.object({
  limit: z.coerce.number().int().positive().max(500).optional(),
  band: z.string().optional(),
  status: z.string().optional(),
});
export type TriageBoardQuery = z.infer<typeof listQuery>;

const listOp: Operation<void, TriageBoardQuery, void, TriageBoardResult> = {
  method: "GET",
  path: () => "/api/agents/triage",
  query: listQuery,
  response: z.custom<TriageBoardResult>(),
};

export const triageBoard = {
  list: listOp,
};
